import ScalarIconCpu_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCpu.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconCpu.vue
var ScalarIconCpu_default = ScalarIconCpu_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCpu_default as default };

//# sourceMappingURL=ScalarIconCpu.js.map